import {Component, Material, MeshComponent, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {PaintballClient} from './paintball-client.js';

/**
 * mute-button
 */
export class MuteButton extends Component {
    static TypeName = 'mute-button';

    /* Properties that are configurable in the editor */

    @property.float(1.0)
    param!: number;

    @property.object()
    eventClientObj!: Object3D;

    @property.string()
    muteIconUrl!: string;

    @property.object()
    muteObj3D!: Object3D;

    selfMute = false;
    eventClient: PaintballClient | null = null;

    muteButton: HTMLElement | null = null;
    muteButtonMat: Material | null = null;

    vrMuteButtonState = 0;

    defaultBgGreenSVG =
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50'%3E%3Ccircle cx='25' cy='25' r='20' style='fill:green;stroke:white;stroke-width:3;' /%3E%3C/svg%3E";
    defaultBgRedSVG =
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50'%3E%3Ccircle cx='25' cy='25' r='20' style='fill:red;stroke:white;stroke-width:3;' /%3E%3C/svg%3E";
    defaultMicSVG = 'speaker.png';
    defaultMicOffSVG = 'speaker.png';

    start() {
        this.muteButtonMat = this.muteObj3D!.getComponent(MeshComponent)!.material;
        this.eventClient = this.eventClientObj.getComponent(PaintballClient);
        window.addEventListener('keydown', this.keyDownCallback.bind(this));
        this.createDynamicHtml();
        this.muteButton = document.getElementById('mute-button');

        if (this.muteButton) {
            // Bind the 'toggleMute' function directly
            this.muteButton.addEventListener('click', this.toggleMute.bind(this));
        }

        this.updateMuteIcon();
    }

    keyDownCallback(e: KeyboardEvent) {
        if (e.key === 'M' || e.key === 'm') {
            this.toggleMuteNow();
        }
    }

    toggleMuteNow() {
        this.selfMute = !this.selfMute;
        this.eventClient!.audioMusic.setVolumeDuringPlayback(this.selfMute ? 0 : 0.1);
        this.updateMuteIcon(); // Update icon based on the mute state
    }

    update(dt: number) {
        this.updateGamepadInput();
    }

    updateGamepadInput() {
        let s = this.engine.xr?.session;
        if (!s) return;

        //Handle input
        for (let i = 0; i < s.inputSources.length; ++i) {
            let input = s!.inputSources[i];
            if (input!.handedness == ['left', 'right'][0]) {
                let gamepad = input!.gamepad;
                if (!gamepad) continue;
                const buttonPress = gamepad!.buttons[5]!.value;

                if (this.vrMuteButtonState != buttonPress) {
                    if (buttonPress === 1) {
                        this.toggleMute();
                    }
                    this.vrMuteButtonState = buttonPress;
                }
            }
        }
    }

    createDynamicHtml() {
        // Background icon (the circle)
        const iconMuteBgSrc = this.defaultBgGreenSVG;
        const iconMuteBg = document.createElement('img');
        iconMuteBg.src = iconMuteBgSrc;
        iconMuteBg.draggable = false;
        iconMuteBg.id = 'mute-button-bg';
        iconMuteBg.setAttribute('data-loaded', 'false');
        iconMuteBg.setAttribute(
            'style',
            'border:10px; bottom:10px; height:50px;width:50px;left:5px; position:absolute; z-index:1;' // Add z-index
        );
        document.body.appendChild(iconMuteBg);

        // Foreground icon (the mute icon)
        const iconMuteFgSrc = this.defaultMicSVG;
        const iconMuteFg = document.createElement('img');
        iconMuteFg.src = iconMuteFgSrc;
        iconMuteFg.draggable = false;
        iconMuteFg.id = 'mute-button';
        iconMuteFg.setAttribute('data-loaded', 'false');
        iconMuteFg.setAttribute(
            'style',
            'border:20px; bottom:22px; height:25px;width:25px;left:17px; position:absolute; z-index:2;' // Ensure foreground is on top
        );
        document.body.appendChild(iconMuteFg);
    }

    toggleMute() {
        this.toggleMuteNow();
        this.updateMuteIcon();
    }

    updateMuteIcon() {
        const muteButton = document.getElementById('mute-button') as HTMLImageElement;
        const mutebg = document.getElementById('mute-button-bg') as HTMLImageElement;

        if (muteButton) {
            if (this.selfMute) {
                muteButton.src = this.defaultMicOffSVG;
                mutebg.src = this.defaultBgRedSVG;
                this.muteButtonMat!.setColor([1, 0, 0, 1]);
            } else {
                muteButton.src = this.defaultMicSVG;
                mutebg.src = this.defaultBgGreenSVG;
                this.muteButtonMat!.setColor([0, 1, 0, 1]);
            }
        }
    }
}
